import { apiSlice } from "@app/api/apiSlice";

export const mainFieldManageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllFieldData: builder.mutation({
      query: (query) => `field_data?size=0`,
    }),
    loadSingleFiledData: builder.mutation({
      query: (id) => `field_data/single/${id}`,
    }),
    deleteFieldData: builder.mutation({
      query: (id) => ({
        url: `field_data/delete/${id}`,
        method: "POST",
      }),
    }),
    saveFieldData: builder.mutation({
      query: (body) => ({
        url: "field_data",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoadAllFieldDataMutation,
  useLoadSingleFiledDataMutation,
  useSaveFieldDataMutation,
  useDeleteFieldDataMutation,
} = mainFieldManageApiSlice;
